module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Semibold-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Semibold-webfont.eot
// module id = 361
// module chunks = 0